import { memo } from "react";
import cn from "classnames";
import Image from "next/image";
import { useStore } from "@hooks/useZustandProvider";
import { useMediaQuery } from "@hooks/useMediaQuery";
// import { useMousePosition } from "@hooks/useMousePosition";
import s from "./EmptySlider.module.scss";

import gallerySvg from "@images/svg/CMS/gallery.svg";
import { toast } from "react-toastify";

const EmptySlider = ({ isSmall, onClick, cursorNotice, collectionType }) => {
  const { isMobile } = useMediaQuery();
  const { cms } = useStore();
  // const { isWidget } = useMousePosition();
  const { isWidget } = cms.page;
  const { isWidgetEditing } = cms.widget;
  const { isEditMode } = cms.uiOptions;

  return (
    <div
      className={cn(s.emptySlider, isSmall && s.small)}
      {...(isEditMode && !(!isWidgetEditing && isWidget)
        ? {
          "data-cursor-notice": cursorNotice,
          "data-collection-type": collectionType,
          onClick,
        } : {
          onClick: () => {
            toast.warning("To edit a widget you need to enable widget editing mode");
          },
        })}
    >
      <div className={s.preview}>
        <Image
          src={gallerySvg}
          fill
          style={{
            objectFit: 'cover',
            objectPosition: 'center'
          }}
          alt="galery preview"
        />
      </div>
      {(!isSmall || isMobile) && (
        <div className={s.header}>
          <div className={s.subTitle}>Gallery & Text</div>
          <div className={s.title}>This area is empty</div>
        </div>
      )}

      <div className={s.subHeader}>
        <div className={s.title}>Double-click to add items</div>
        <div className={s.subTitle}>
          To customise styling, go to block settings in the structure menu
        </div>
      </div>
    </div>
  );
};

export default memo(EmptySlider);
